<template>
  <div>
    <div
      id="viewer"
      dir="rtl"
      style="max-height: 40vh !important; overflow-y: scroll"
    ></div>
  </div>
</template>
<script>
// import jsonfile from '../../../reports/rpt.json'
export default {
  data() {
    return {};
  },
  mounted: function () {
    // window.Stimulsoft.Base.StiLicense.Key ="6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7plofUOqPB1a4HBIXJB621mau2oiAIj+ysU7gKUXfjn/D5BocmduNB+ZMiDGPxFrAp3PoD0nYNkkWh8r7gBZ1v/JZSXGE3bQDrCQCNSy6mgby+iFAMV8/PuZ1z77U+Xz3fkpbm6MYQXYp3cQooLGLUti7k1TFWrnawT0iEEDJ2iRcU9wLqn2g9UiWesEZtKwI/UmEI2T7nv5NbgV+CHguu6QU4WWzFpIgW+3LUnKCT/vCDY+ymzgycw9A9+HFSzARiPzgOaAuQYrFDpzhXV+ZeX31AxWlnzjDWqpfluygSNPtGul5gyNt2CEoJD1Yom0VN9fvRonYsMsimkFFx2AwyVpPcs+JfVBtpPbTcZscnzUdmiIvxv8Gcin6sNSibM6in/uUKFt3bVgW/XeMYa7MLGF53kvBSwi78poUDigA2n12SmghLR0AHxyEDIgZGOTbNI33GWu7ZsPBeUdGu55R8w=";

// خواندن کدهای فایل فرمت پرفراژ ار دیتا بیست که به صورت پراپز ارسال شده اند
    var mrtfile = this.MrtToStr;
    // یک گزارش استیمولی جدید میسازیم
    // var report = new window.Stimulsoft.Report.StiReport();
    // فایلهای فرمت پرفراژ را در گزارش لود میکنیم
    report.load(mrtfile);
    // تابع زیر دیتای خوانده شده از پراپز را در فرمت پرفراژ لود میکند
    report.regData("data", "da  ta", this.dataFromApi);

    // ساخت آبجکت تنظیمات پرفراژ
    // var options = new window.Stimulsoft.Viewer.StiViewerOptions();
    // راست به چپ کردن متن
    options.appearance.rightToLeft = true;
    // نام فونت نمایش پرفراژ 
    // احتمالا میشه با یه کمبو فونت رو انتخاب کرد و به این کامپوننت پاس داد
    options.toolbar.fontFamily = "Tahoma";
    options.toolbar.showAboutButton = false;
    // options.toolbar.displayMode = window.Stimulsoft.Viewer.StiToolbarDisplayMode.Simple;

// شرط زیر بررسی میکند پرفراژ نمایش داده شود یا مستقیم چاپ شود
    if (this.IsPreview) {
      // یک نمایش دهنده برای نمایش پرفراژ میسازد و و گزارش ساخته شده در بالا به آن پاس داده میشود
      // var viewer = new window.Stimulsoft.Viewer.StiViewer(
      //   options,
      //   "StiViewer",
      //   false
      // );
      // viewer.report = report;
      // نمایش دهنده گزارش را لود میکند
      viewer.renderHtml("viewer");
    } else {
      // در صورت پرینت مستقیم گزارش را پرینت میکند
      report.renderAsync(function () {
        report.print();
      });
    }
  },
  props: ["MrtToStr", "dataFromApi", "IsPreview"],
};
</script>
<style scoped></style>
